import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Profile(){
  const { user, updateProfile } = useAuth();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [message, setMessage] = useState('');

  if (!user) return null;

  async function handleSave(e){
    e && e.preventDefault && e.preventDefault();
    setMessage('Saving...');
    try{
      // update local profile state; backend-authoritative update may not be implemented
      await updateProfile({ name: name.trim(), email: email.trim() });
      setMessage('Profile updated locally. Server update not implemented.');
      setEditing(false);
      setTimeout(()=>setMessage(''), 3000);
    }catch(err){
      setMessage('Failed to update profile');
    }
  }

  function RolePanel(){
    switch((user.role||'').toString()){
      case 'Manager':
        return (
          <div className="card card-container">
            <h3 className="card-title">Manager tools</h3>
            <p className="muted">Quick links for event management and reports.</p>
            <div style={{marginTop:12}}>
              <button className="btn btn-primary" onClick={()=>navigate('/dashboard')}>Go to Manager Dashboard</button>
              <button className="btn btn-outline" style={{marginLeft:8}} onClick={()=>navigate('/events')}>Create / Manage Events</button>
              <button className="btn btn-ghost" style={{marginLeft:8}} onClick={()=>navigate('/reports')}>Reports</button>
            </div>
          </div>
        );
      case 'Clerk':
        return (
          <div className="card card-container">
            <h3 className="card-title">Clerk tools</h3>
            <p className="muted">Quick access to bookings and transactions.</p>
            <div style={{marginTop:12}}>
              <button className="btn btn-primary" onClick={()=>navigate('/bookings')}>Manage Bookings</button>
              <button className="btn btn-outline" style={{marginLeft:8}} onClick={()=>navigate('/tickets')}>Ticketing</button>
            </div>
          </div>
        );
      case 'Security':
        return (
          <div className="card card-container">
            <h3 className="card-title">Security dashboard</h3>
            <p className="muted">Access security checks and event entry controls.</p>
            <div style={{marginTop:12}}>
              <button className="btn btn-primary" onClick={()=>navigate('/security')}>Open Security Panel</button>
            </div>
          </div>
        );
      case 'Admin':
        return (
          <div className="card card-container">
            <h3 className="card-title">Administrator</h3>
            <p className="muted">System-wide settings and user management.</p>
            <div style={{marginTop:12}}>
              <button className="btn btn-primary" onClick={()=>navigate('/admin')}>Admin Console</button>
              <button className="btn btn-outline" style={{marginLeft:8}} onClick={()=>navigate('/admin/financial-reports')}>Financial Reports</button>
            </div>
          </div>
        );
      default:
        return (
          <div className="card card-container">
            <h3 className="card-title">User</h3>
            <p className="muted">View your bookings and events.</p>
            <div style={{marginTop:12}}>
              <button className="btn btn-primary" onClick={()=>navigate('/bookings')}>My Bookings</button>
              <button className="btn btn-outline" style={{marginLeft:8}} onClick={()=>navigate('/events')}>Browse Events</button>
            </div>
          </div>
        );
    }
  }

  return (
    <div className="p-6">
      <header className="mb-4">
        <h2 className="text-2xl">Profile</h2>
        <div className="muted">Manage your profile and quick links for your role.</div>
      </header>

      <div className="container-grid">
        <div>
          <div className="card card-container">
            <h3 className="card-title">Account</h3>
            {!editing ? (
              <div>
                <div style={{marginBottom:8}}><strong>Name:</strong> {user.name}</div>
                <div style={{marginBottom:8}}><strong>Email:</strong> {user.email}</div>
                <div style={{marginBottom:8}}><strong>Role:</strong> {user.role}</div>
                <div>
                  <button className="btn btn-primary" onClick={()=>setEditing(true)}>Edit</button>
                </div>
                {message && <div style={{marginTop:10}} className="muted">{message}</div>}
              </div>
            ) : (
              <form onSubmit={handleSave}>
                <div className="form-group">
                  <label>Name</label>
                  <input className="form-input" value={name} onChange={e=>setName(e.target.value)} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input className="form-input" value={email} onChange={e=>setEmail(e.target.value)} />
                </div>
                <div style={{marginTop:12}}>
                  <button className="btn btn-primary" type="submit">Save</button>
                  <button className="btn btn-outline" type="button" onClick={()=>{ setEditing(false); setName(user.name||''); setEmail(user.email||''); }}>Cancel</button>
                </div>
                {message && <div style={{marginTop:10}} className="muted">{message}</div>}
              </form>
            )}
          </div>

          <div style={{marginTop:12}}>
            <RolePanel />
          </div>
        </div>

        <aside>
          <div className="card card-container">
            <h4 className="card-title">Quick Links</h4>
            <ul style={{marginTop:8}}>
              <li><button className="btn btn-ghost" onClick={()=>navigate('/dashboard')}>Dashboard</button></li>
              <li><button className="btn btn-ghost" onClick={()=>navigate('/events')}>Events</button></li>
              <li><button className="btn btn-ghost" onClick={()=>navigate('/bookings')}>Bookings</button></li>
              <li><button className="btn btn-ghost" onClick={()=>navigate('/reports')}>Reports</button></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}
